import React from 'react';

export const ErrorIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.06771 1.33333C4.754 1.33333 2.06771 4.01962 2.06771 7.33333C2.06771 10.647 4.754 13.3333 8.06771 13.3333C11.3814 13.3333 14.0677 10.647 14.0677 7.33333C14.0677 4.01962 11.3814 1.33333 8.06771 1.33333ZM0.734375 7.33333C0.734375 3.28324 4.01762 0 8.06771 0C12.1178 0 15.401 3.28324 15.401 7.33333C15.401 11.3834 12.1178 14.6667 8.06771 14.6667C4.01762 14.6667 0.734375 11.3834 0.734375 7.33333Z"
      fill="var(--color-bg-base)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.06771 4C8.4359 4 8.73437 4.29848 8.73437 4.66667V7.33333C8.73437 7.70152 8.4359 8 8.06771 8C7.69952 8 7.40104 7.70152 7.40104 7.33333V4.66667C7.40104 4.29848 7.69952 4 8.06771 4Z"
      fill="var(--color-bg-base)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.40104 10C7.40104 9.63181 7.69952 9.33333 8.06771 9.33333H8.07437C8.44256 9.33333 8.74104 9.63181 8.74104 10C8.74104 10.3682 8.44256 10.6667 8.07437 10.6667H8.06771C7.69952 10.6667 7.40104 10.3682 7.40104 10Z"
      fill="var(--color-bg-base)"
    />
  </svg>
);
